import { type Transition, type Variant, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

export enum ResurrectionSharedVariant {
    Initial = 'sharedInitial',
    Show = 'sharedShow',
    Exit = 'sharedExit',
}

const resurrectionCommonTransition: Transition = {
    staggerChildren: framerMotion.duration.fastest / 2,
};

const resurrectionCommonVariant: Variant = {
    transition: resurrectionCommonTransition,
};

export const resurrectionVariants: Variants = {
    [ResurrectionSharedVariant.Initial]: resurrectionCommonVariant,
    [ResurrectionSharedVariant.Exit]: resurrectionCommonVariant,
    [ResurrectionSharedVariant.Show]: resurrectionCommonVariant,
};

///
/// Character

export const characterVariants: Variants = {
    [ResurrectionSharedVariant.Initial]: {
        opacity: 0,
        translateY: '200%',
    },
    [ResurrectionSharedVariant.Show]: {
        opacity: 1,
        translateY: '0%',
    },
    [ResurrectionSharedVariant.Exit]: {
        opacity: 0,
        translateY: '-200%',
    },
};

export const characterTransition: Transition = {
    type: 'spring',
    duration: framerMotion.duration.slower,
};
